import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';

import { BrandMark } from './BrandMark';

const navigation = [
  { label: 'Competition', to: '/competition' },
  { label: 'Rules', to: '/rules' },
  { label: 'FAQs', to: '/faq' },
  { label: 'Contact', to: '/contact' },
];

export function PublicHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header sticky top-0 z-50 border-b border-slate-200/80 bg-white/95 backdrop-blur-xl">
      <div className="mx-auto flex h-[4.75rem] max-w-7xl items-center justify-between px-5 sm:px-8 lg:px-10">
        <BrandMark />
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary navigation">
          {navigation.map((item) => (
            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`} key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
          <NavLink className="nav-link" to="/portal/sign-in">Participant login</NavLink>
          <NavLink className="button button-primary min-h-10 px-5" to="/register">Register now</NavLink>
        </nav>
        <button
          className="mobile-menu-button grid size-11 place-items-center rounded-xl border border-slate-200 text-navy lg:hidden"
          type="button"
          aria-expanded={open}
          aria-controls="mobile-navigation"
          aria-label={open ? 'Close navigation' : 'Open navigation'}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X className="size-5" aria-hidden="true" /> : <Menu className="size-5" aria-hidden="true" />}
        </button>
      </div>
      {open && (
        <nav id="mobile-navigation" className="mobile-navigation border-t border-slate-100 bg-white px-5 py-5 lg:hidden" aria-label="Mobile navigation">
          <div className="mx-auto grid max-w-7xl gap-1">
            {navigation.map((item) => (
              <NavLink className="rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50" key={item.to} to={item.to} onClick={() => setOpen(false)}>
                {item.label}
              </NavLink>
            ))}
            <NavLink className="rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50" to="/portal/sign-in" onClick={() => setOpen(false)}>Participant login</NavLink>
            <NavLink className="button button-primary mt-3" to="/register" onClick={() => setOpen(false)}>Register now</NavLink>
          </div>
        </nav>
      )}
    </header>
  );
}
